import DoMarkdown from "./DoMarkdown";
import OnMatrixDetailPanelVisibleChanged from "./OnMatrixDetailPanelVisibleChanged";

function OnSurveyInstanceCreatedCommon(sender: any, options: any) {
  if (options.area === "property-grid") {
    const toolboxCaptchaCategory = options.survey.getPageByName("toolboxCaptchaCategory");
    if (toolboxCaptchaCategory) {
      toolboxCaptchaCategory.iconName = "icon-captcha";
    }
    const toolboxMapperCategory = options.survey.getPageByName("toolboxMapperCategory");
    if (toolboxMapperCategory) {
      toolboxMapperCategory.iconName = "icon-mapper";
    }

    const timerTab = options.survey.getPageByName("timer");
    if (timerTab) {
      timerTab.delete();
    }
  }

  if (
    options.reason === "theme" ||
    options.reason === "preview" ||
    options.reason === "designer" ||
    options.reason === "condition-builder" ||
    options.reason === "logic-item-editor" ||
    options.reason === "logic-items"
  ) {
    options.survey.onTextMarkdown.add(DoMarkdown);
  }

  if (options.area === "property-grid") {
    options.survey.onMatrixDetailPanelVisibleChanged.add(
      (optionsSender: any, optionsOptions: any) => {
        OnMatrixDetailPanelVisibleChanged(optionsSender, optionsOptions);
      },
    );
    options.survey.onValueChanged.add((optionsSender: any, optionsOptions: any) => {
      if (optionsOptions.name === "contactMap" || optionsOptions.name === "leadMap") {
        const choices = optionsSender.getQuestionByName("choices");
        if (choices && Array.isArray(choices.visibleRows)) {
          choices.visibleRows.forEach((row: any) => row.hideDetailPanel(true));
        }
      }
    });
  }
}

export default OnSurveyInstanceCreatedCommon;
